export default __webpack_public_path__ + "static/media/workbench.279354bc.svg";